<template>
  <Page>
    <template #right>
      <van-count-down
        ref="countDown"
        :time="time"
        format="sss"
        @finish="countdownfinish"
      />
    </template>
    <div class="user-express-list">
      <UserExpressItem
        class="user-express-item"
        v-for="(item, index) in expressList"
        :key="index"
        :express="item"
        @pick-up="handlePickup"
      />
      <van-dialog
        v-model="showOverdue"
        title="微信扫码支付"
        confirm-button-text="支付完成"
        class="overdue-dialog"
        @confirm="handlePayCompleted"
      >
        <qr-code class="pay-img" :text="payQrcode" :size="270"></qr-code>
      </van-dialog>
      <van-dialog
        style="transform: scale(2) translate3d(-28%, -24%, 0);"
        v-model="showPhone"
        :title="`请输入尾号为${currentItem.phone ? currentItem.phone.slice(7,11) : currentItem.phone}的手机号码`"
        confirm-button-text="确认"
        class="overdue-dialog"
        @confirm="handleComfirmPhone"
        @cancel="handleCancelPhone"
        :showCancelButton="true"
        close-button-text="取消"
      >
        <van-cell-group inset>
          <van-field v-model="phone" label="手机号" placeholder="请输入完整手机号" type="tel" size="large" />
        </van-cell-group>
      </van-dialog>
    </div>
  </Page>
</template>

<script>
import UserExpressItem from "@/components/userExpressItem/index.vue";
import {
  userPickup,
  getUserExpressList,
  overtimeQrcodeUrl,
  comfirmCustomer,
  checkComfirmCustom,
} from "@/apis/index";
import { Toast } from 'vant';
import { playVoice } from "@/utils";
export default {
  props: {},
  data() {
    return {
      time: 120 * 1000,
      expressList: [],
      showOverdue: false,
      // 逾期支付二维码
      payQrcode: null,
      // 当前取件快递Id
      currentId: null,
      loading: false,
      showPhone: false,
      phone: '',
      currentItem: {},
      phoneDialogClose: false,
    };
  },
  components: {
    UserExpressItem
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const laoding = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "查询中..."
      });
      const [err, data] = await this.awaitTo(
        getUserExpressList(this.$route.query)
      );
      if (!err) {
        this.expressList = data;
        if (!data.length) {
          this.$router.push("/user/pick");
        }
      }
      laoding.clear();
    },
  async handleComfirmPhone() {
    const mobileReg = /^1[3-9]\d{9}$/;
    if(mobileReg.test(this.phone) === false) {
      this.$toast.fail('请输入正确的手机号');
      return;
    }
    await comfirmCustomer({
      phone: this.phone,
      code: this.currentItem.code,
      subfix: this.currentItem.phone,
    })
    this.handlePickup(this.currentItem);
  },
  handleCancelPhone() {
    this.showPhone = false;
    this.phoneDialogClose = true;
    this.handlePickup(this.currentItem);
  },
    // 取件
    async handlePickup(currentItem) {
      const id = currentItem._id;
      this.currentItem = currentItem;
      if(this.currentItem.phone.includes('*') && this.phoneDialogClose === false) {
        const data = await checkComfirmCustom(currentItem.phone)
        if(data) {
          this.phone = '';
          this.showPhone = true;
          return;
        }
      }
      // playVoice("openWait");
      this.$toast.loading({
        message: "开箱中，请稍等...",
        forbidClick: true,
        loadingType: "spinner"
      });

      this.currentId = id;

      const [err, res] = await this.awaitTo(userPickup(id));
      this.$toast.clear();
      if (err) {
        if (err.code === 8006) {
          this.handleOverdue({ message: err.message, id });
          return;
        }

        this.$toast.fail(err.message);
        return;
      }

      if (res.success) {
        this.handlePickSuccess({ id, serial: res.serial });
      } else {
        this.handlePickFail({ id });
      }
    },

    // 逾期处理
    handleOverdue({ message, id }) {
      // playVoice("overFlu");
      this.$dialog
        .confirm({
          message,
          theme: "round-button"
        })
        .then(() => {
          this.showOverdue = true;
          this.getOvertimeQrcodeUrl(id);
        });
    },

    // 获取逾期支付二维码
    async getOvertimeQrcodeUrl(id) {
      const [err, res] = await this.awaitTo(overtimeQrcodeUrl(id));
      if (err) {
        return;
      }
      this.payQrcode = res.url;
    },

    // 支付完成
    handlePayCompleted() {
      this.handlePickup(this.currentId);
    },

    // 取件成功
    handlePickSuccess({ id, serial }) {
      console.log(id);
      playVoice("pickSuccess");
      this.$dialog
        .alert({
          className: 'bigDialog',
          title: "开箱成功",
          // message: `箱子编号为:${serial}，请及时查看，取件成功后请关闭柜门`,
          message: `柜子编号为: <b style="color:red; font-size: 60px">${serial}</b>，取件成功后请关闭柜门`,
          theme: "round-button"
        })
        .then(() => {
          // const targetIndex = this.expressList.findIndex(
          //   item => item._id === id
          // );
          //
          // this.expressList.splice(targetIndex, 1);
          this.takePickedPackage(id);
          if (!this.expressList.length) {
            this.$router.push("/user/pick");
          }
        });
    },
    takePickedPackage(id) {
      const arr = [];
      const expressList = this.expressList;
      for (let i = 0; i < expressList.length; i++) {
        if (expressList[i]._id !== id) {
          arr.push(expressList[i]);
        }
      }
      this.expressList = arr;
    },
    countdownfinish() {
      this.$router.push("/user/pick");
    },
    // 取件失败
    handlePickFail({ id }) {
      playVoice("pickFail");
      this.$dialog
        .confirm({
          message: "取件失败",
          theme: "round-button",
          confirmButtonText: "重试"
        })
        .then(() => {
          this.handlePickup(id);
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss">
.user-express {
  &-list {
    padding: 0 rem(30);
  }
  &-item {
    margin-top: rem(40);
  }
}

.overdue-dialog {
  .van-dialog__content {
    padding: rem(20);
    text-align: center;
  }
}
.pay-img {
  width: rem(280);
  height: rem(220);
  margin: 0 auto;
}
.bigDialog {
  width: 60%;
  font-size: 32px;
  .van-dialog__header {
    padding: 20px;
    margin-top: 20px;
    line-height: 40px;
  }
  .van-dialog__message,.van-dialog__message--has-title {
    text-align: center;
    font-size: 42px;
    padding: 20px 40px;
    line-height: 2;
  }
  .van-dialog__footer {
    padding: 20px 0;
  }
  .van-button {
    
  }
  .van-button__text{
    font-size: 32px;
  }
}
</style>
